import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
import { ContentResultSearchStudentById } from "views/components/AttendanceList/styles";
//#region Images
import errorWindow from "img/error_window.svg";
import CustomButton from "components/CustomButton/CustomButton";
//#endregion

const DialogResultSearchStudent = ({
	dialog,
	studentToAdd,
	addStudentReservation,
}) => {
	return (
		<DialogAlertAction
			show={dialog.value}
			toggleShow={dialog.toggle}
			contentComponent={
				<ContentResultSearchStudentById
					className={!studentToAdd.name ? "not-found" : ""}
				>
					{!studentToAdd.name && (
						<img
							className="not-found-image"
							src={errorWindow}
							alt="UTP imagen de no encontrado"
						/>
					)}
					<h3 className="title">Resultados de búsqueda</h3>
					<h5>
						Código agregado: <strong>{studentToAdd.id}</strong>
					</h5>
					{studentToAdd.name ? (
						<h3 className="description">
							Nombre de alumno: {studentToAdd.name}
						</h3>
					) : (
						<h3 className="description">
							El código agregado no existe
						</h3>
					)}
				</ContentResultSearchStudentById>
			}
			noImage={!studentToAdd.name}
		>
			{studentToAdd.name ? (
				<>
					<CustomButton
						size="medium"
						text="Agregar"
						onClick={addStudentReservation}
					/>
					<CustomButton
						variant="secondary"
						size="medium"
						text="Cancelar"
						onClick={() => dialog.set(false)}
					/>
				</>
			) : (
				<CustomButton
					text="Volver a intentarlo"
					width="200px"
					onClick={() => dialog.set(false)}
				/>
			)}
		</DialogAlertAction>
	);
};

export default DialogResultSearchStudent;
